import React from 'react'
import './Contact.css';

function Contact() {
    return (
      <div className="contact">
        <div className="part1">
          <h2>CONTACT US</h2>
        </div>
        <div className="part2 container">
          <div className="row">
            <div className="col-lg-4">
              <div className="info">
                <h6>CAIRO</h6>
                <p>
                  Head Office <br /> 35th St. Elmaadi <br />
                  Cairo <br /> Egypt
                </p>
                <p>+201022886619</p>
              </div>
              <div className="info">
                <h6>SUEZ</h6>
                <p>
                  3rd floor <br /> 10 East 52nd Street <br /> Suez Egypt
                </p>
                <p>+201022886619</p>
              </div>
            </div>
            <div className="col-lg-8">
              <h5>SEND US A MESSAGE</h5>
              <div className="input1">
                <input className="text1" type="text" placeholder="Full Name" />
              </div>
              <div className="input2">
                <input className="text2" type="text" placeholder="Email" />
              </div>
              <div className="input3">
                <textarea
                  className="text3"
                  placeholder="Your Massage"
                ></textarea>
              </div>
              <div className="input4">
                <input className="submit" type="submit" value="Send Massage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Contact
